module.exports = __webpack_public_path__ + "static/media/Decisions_Step4_Image10.237dff70.jpg";